import PublicHeader from "@/components/PublicHeader";
import PublicFooter from "@/components/PublicFooter";
import { AlertTriangle } from "lucide-react";

export default function DisclaimerPage() {
  return (
    <>
      <PublicHeader />
      <main className="max-w-4xl mx-auto px-4 py-10 pb-24" data-testid="disclaimer-page">
        <div className="tag-cat mb-4">अस्वीकरण</div>
        <h1 className="font-devnagri-heading text-4xl sm:text-5xl font-black text-[#0F172A] leading-tight flex items-center gap-3">
          <AlertTriangle className="w-10 h-10 text-amber-500"/>Disclaimer
        </h1>
        <p className="text-slate-500 mt-2 text-sm">अंतिम अपडेट: {new Date().toLocaleDateString("hi-IN", { year: "numeric", month: "long", day: "numeric" })}</p>

        <div className="prose prose-slate max-w-none mt-6 space-y-5 text-slate-700 leading-relaxed">
          <p><b>INDIAN-NEWS-21</b> (<code>indiannews21.com</code>) पर प्रकाशित सभी समाचार, लेख, चित्र, वीडियो और अन्य सामग्री केवल सामान्य <b>सूचना उद्देश्य</b> के लिए है। हम सटीक, अद्यतन और विश्वसनीय जानकारी प्रस्तुत करने का हरसंभव प्रयास करते हैं, फिर भी हम इसकी पूर्ण शुद्धता, समयबद्धता या उपयुक्तता की कोई गारंटी नहीं देते।</p>

          <h2 className="font-devnagri-heading text-2xl font-black text-[#0F172A] mt-8">1. समाचार सामग्री</h2>
          <p>हमारे पोर्टल पर प्रकाशित समाचार विभिन्न स्रोतों — हमारे स्वयं के रिपोर्टर, समाचार एजेंसियों, प्रेस विज्ञप्तियों, सोशल मीडिया और सार्वजनिक रूप से उपलब्ध जानकारी — से एकत्र किए जाते हैं। किसी भी खबर पर कार्रवाई करने से पहले पाठकों से अपेक्षा की जाती है कि वे स्वयं भी उस जानकारी की पुष्टि करें।</p>

          <h2 className="font-devnagri-heading text-2xl font-black text-[#0F172A] mt-8">2. विचार एवं मत</h2>
          <p>संपादकीय, ब्लॉग, ओपिनियन कॉलम, पाठकों के पत्र आदि में व्यक्त विचार लेखकों के व्यक्तिगत हैं। ये विचार आवश्यक रूप से INDIAN-NEWS-21 के संपादकीय दृष्टिकोण या नीति का प्रतिनिधित्व नहीं करते।</p>

          <h2 className="font-devnagri-heading text-2xl font-black text-[#0F172A] mt-8">3. बाहरी लिंक</h2>
          <p>पोर्टल पर कुछ बाहरी वेबसाइटों/स्रोतों के लिंक हो सकते हैं। इन बाहरी साइटों की सामग्री, नीतियों या प्रथाओं के लिए INDIAN-NEWS-21 ज़िम्मेदार नहीं है।</p>

          <h2 className="font-devnagri-heading text-2xl font-black text-[#0F172A] mt-8">4. विज्ञापन एवं प्रायोजित सामग्री</h2>
          <p>वेबसाइट पर दिखाए गए विज्ञापन तीसरे पक्ष द्वारा दिए जाते हैं। विज्ञापित उत्पादों/सेवाओं की गुणवत्ता, दावे या शर्तों की ज़िम्मेदारी संबंधित विज्ञापनदाता की है।</p>

          <h2 className="font-devnagri-heading text-2xl font-black text-[#0F172A] mt-8">5. त्रुटियाँ एवं सुधार</h2>
          <p>यदि आप हमारी किसी सामग्री में तथ्यात्मक त्रुटि पाते हैं, तो कृपया हमें <a href="mailto:mdjkbaba786@gmail.com" className="text-[#DC2626] font-bold hover:underline">mdjkbaba786@gmail.com</a> पर सूचित करें। हम त्वरित जांच करके आवश्यक सुधार सार्वजनिक रूप से प्रकाशित करेंगे।</p>

          <h2 className="font-devnagri-heading text-2xl font-black text-[#0F172A] mt-8">6. देयता की सीमा</h2>
          <p>किसी भी परिस्थिति में INDIAN-NEWS-21, इसके स्वामी, संपादक, कर्मचारी या सहयोगी वेबसाइट के उपयोग या किसी भी सामग्री पर विश्वास करके किए गए कार्यों से उत्पन्न किसी भी प्रकार की प्रत्यक्ष, अप्रत्यक्ष, आकस्मिक, विशेष या परिणामी हानि के लिए ज़िम्मेदार नहीं होंगे।</p>

          <h2 className="font-devnagri-heading text-2xl font-black text-[#0F172A] mt-8">7. कॉपीराइट</h2>
          <p>पोर्टल की सम्पूर्ण सामग्री © INDIAN-NEWS-21 के अंतर्गत सुरक्षित है। बिना पूर्व लिखित अनुमति के इसे किसी भी माध्यम से पुनःप्रकाशित करना कानूनन अपराध है।</p>

          <h2 className="font-devnagri-heading text-2xl font-black text-[#0F172A] mt-8">8. अधिकार क्षेत्र</h2>
          <p>इस Disclaimer से संबंधित सभी विवाद केवल <b>सूरजपुर (छत्तीसगढ़)</b> न्यायालय के अधिकार क्षेत्र में आएंगे।</p>

          <div className="mt-8 p-4 rounded-lg bg-slate-50 border-l-4 border-[#DC2626] text-sm">
            <b>संपादकीय संपर्क:</b> प्रधान संपादक JAKIR MOMIN · +91 8463860303 · सिरसी नवापारा, सूरजपुर, छत्तीसगढ़ — 497231
          </div>
        </div>
      </main>
      <PublicFooter />
    </>
  );
}
